<template>
  <mHeader></mHeader>
  <router-view />
  <mFooter></mFooter>
</template>
<script>
import { defineComponent } from "vue";
import mHeader from "@/components/mHeader";
import mFooter from "@/components/mFooter";
export default defineComponent({
  components: { mHeader, mFooter },
});
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  overflow: hidden;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
